// Dynamic inpage menu creation based on the anchor
// inserted inside the various row headings
import './_jquery';
import 'waypoints/lib/jquery.waypoints.js';
import throttle from 'lodash.throttle'

const activateMenuItem = function($item) {
  $item.addClass('component-anchor-nav__items__item--active');
  $item.removeClass('component-anchor-nav__items__item');
  $item.siblings().removeClass('component-anchor-nav__items__item--active');
  $item.siblings().addClass('component-anchor-nav__items__item');
};

const navigateToAnchor = function(targetAnchor, menuAnchor, directNavigationFromURL) {
  let anchor, anchorOffset, anchoredSectionHeight, offset;

  if (directNavigationFromURL == null) {
    directNavigationFromURL = false;
  }

  if (targetAnchor === 'top') {
    offset = 0;
  } else if ($('.component-anchor-nav').length > 0) {
    if (targetAnchor[0] === '#') {
      anchor = targetAnchor.substr(1);
    } else {
      anchor = targetAnchor;
    }

    anchor = decodeURI(anchor);
    anchorOffset = $('a[name="' + anchor + '"]').offset();

    if ((anchorOffset != null) && directNavigationFromURL) {
      // Non sono in grado di capire il perché, ma l'ho dimostrato empiricamente: quando
      // lo scroll verso un'àncora avviene non per una interazione con il menu predisposto,
      // ma perché abbiamo una àncora nell'URL al primo caricamento della pagina, allora
      // è necessario rimuovere dall'offset di scroll l'altezza della sezione che stiamo
      // andando a mostrare
      anchoredSectionHeight = $('a[name="' + anchor + '"]').parent().parent().outerHeight();
      anchorOffset.top -= anchoredSectionHeight + heightFromTop(true);
      offset = anchorOffset.top;
    } else if (anchorOffset != null) {
      anchorOffset.top -= 190;
      offset = anchorOffset.top;
    } else {
      offset = 190;
    }
  }

  $('html, body').animate({ scrollTop: offset }, 800, function() {
    if (targetAnchor === 'top') {
      return document.location.hash = '';
    } else {
      menuAnchor = !menuAnchor ? $('a[href="' + anchor + '"]') : menuAnchor;
      activateMenuItem(menuAnchor);
      //Preveniamo l'alterazione della history in due casi:
      //- se `anchor` è undefined
      //- se `origin` è null
      //Con l'existence operator di coffeescript sia undefined che null sono gestiti.
      //Ci sono casi particolari in cui l'origin può essere null e l'alterazione della history
      //può quindi generare errori di sicurezza in alcuni browser.
      if ((anchor != null) && (typeof origin !== "undefined" && origin !== null)) {
        history.pushState(null, null, '#' + anchor);
      }
    }
  });
};

let waypointTargetElement = null;
if ($('.site-header').length > 0) {
  waypointTargetElement = $('.site-header').first().parent().next();
} else if ($('.breadcrumb--fixed').length > 0) {
  waypointTargetElement = $('.breadcrumb--fixed')[0];
} else {
  waypointTargetElement = $('.site-content')[0];
}

if (typeof waypointTargetElement !== "undefined" && waypointTargetElement !== null) {
  new Waypoint({
    element: waypointTargetElement,
    handler: function(direction) {
      let $iconArrowTop;

      if (direction === 'up') {
        $('.icon--arrow-top').css('visibility', 'hidden').css('opacity', 0).unbind('click');
      }

      if (direction === 'down') {
        $iconArrowTop = $('.icon--arrow-top');
        return $iconArrowTop.css('visibility', 'visible').css('opacity', 0.85).on('click', function(ev) {
          ev.preventDefault();
          navigateToAnchor('top');
        });
      }
    }
  });
}

$('.component-anchor-nav__items').on('click', '.component-anchor-nav__items__item', function(ev) {
  let anchor;

  ev.preventDefault();
  ev.stopImmediatePropagation();
  anchor = ev.target.getAttribute('href');
  navigateToAnchor(anchor, $(this));
});

$('.component-headings__anchor').each(function() {
  let anchorName, newMenuItem;

  newMenuItem = function(name) {
    return $('<a></a>').attr('href', '#' + name).text(unescape(name.replace(/\_/gim, ' '))).addClass('component-anchor-nav__items__item');
  };

  anchorName = $(this).attr('name');
  return $('.component-anchor-nav__items').append(newMenuItem(anchorName));
});

$('a[name]').each(function() {
  let that, waypointUp;
  that = $(this);

  waypointUp = new Waypoint({
    element: that,
    handler: function(direction) {
      let anchor;
      if (direction === 'down') {
        anchor = $(this.element).attr('name');
        activateMenuItem($('.component-anchor-nav__items__item[href="#' + anchor + '"]'));
      }
    },
    offset: 190
  });

  return waypointUp = new Waypoint({
    element: that,
    handler: function(direction) {
      let anchor;
      if (direction === 'up') {
        anchor = $(this.element).attr('name');
        activateMenuItem($('.component-anchor-nav__items__item[href="#' + anchor + '"]'));
      }
    },
    offset: 180
  });
});

const fixAnchorNav = function(status, heightFromTop) {
  let parentHeight;

  parentHeight = $('.component-anchor-nav').outerHeight();

  $('.component-anchor-nav').parent('.row_layout').attr('style', 'min-height: ' + parentHeight + 'px');

  if (status === 'fix') {
    if (!$('.component-anchor-nav').hasClass('component-anchor-nav--fixed')) {
      $('.component-anchor-nav').addClass('component-anchor-nav--fixed');
    }
    $('.component-anchor-nav').attr('style', 'top: ' + heightFromTop + 'px');
  }

  if (status === 'unfix') {
    if ($('.component-anchor-nav').hasClass('component-anchor-nav--fixed')) {
      $('.component-anchor-nav').removeClass('component-anchor-nav--fixed');
    }
    $('.component-anchor-nav').removeAttr('style');
  }

  if (typeof Waypoint !== "undefined" && Waypoint !== null) {
    Waypoint.refreshAll()
  }
};

// heightFromTop di che cosa? Credo che si intenda l'altezza dei vari blocchi `fixed` a top
// della pagina e quindi l'altezza che bisogna considerare in aggiunta a quella dell'offset
// di un certo elemento di modo da non "nasconderlo" dietro a tali elementi `fixed`
const heightFromTop = function(firstLoad) {
  let breadcrumbHeight, distance, menuHeight;

  distance = 0;

  if (firstLoad || window.pageYOffset < 26) {
    menuHeight = 85.75;
    breadcrumbHeight = 37.66;
  } else {
    menuHeight = $('.site-header__components--fixed').outerHeight();
    breadcrumbHeight = $('.breadcrumb--fixed').outerHeight();
  }

  if ($.isNumeric(menuHeight)) {
    distance = distance + menuHeight;
  }

  if ($.isNumeric(breadcrumbHeight) && $('[data-breadcrumb-missing]').length <= 0) {
    distance = distance + breadcrumbHeight;
  }

  return distance;
};

jQuery(function() {
  let $item, anchorNavigationScrollHandler, breakpoint, initialHeight, prevScroll, scroll;

  prevScroll = $(window).scrollTop();
  scroll = $(window).scrollTop();

  if ($('.component-anchor-nav').offset() != null) {
    initialHeight = $('.component-anchor-nav').offset().top;
    breakpoint = initialHeight - heightFromTop(true);

    $(window).ready(function() {
      if (window.pageYOffset >= breakpoint) {
        fixAnchorNav('fix', heightFromTop(true));
      } else {
        fixAnchorNav('unfix');
      }
    });

    anchorNavigationScrollHandler = function() {
      let height;
      prevScroll = scroll;
      scroll = $(window).scrollTop();
      height = heightFromTop(false);
      if (scroll > prevScroll && (scroll > breakpoint && prevScroll <= breakpoint)) {
        fixAnchorNav('fix', height);
      }
      if (scroll < prevScroll && (scroll <= breakpoint && prevScroll > breakpoint)) {
        fixAnchorNav('unfix');
      }
    };

    $(window).scroll(throttle(anchorNavigationScrollHandler, 200));
  }

  // Se al load della pagina ho già un'àncora nell'URL allora forso subito la navigazione verso
  // la relativa sezione
  if (document.location.hash.length > 1) {
    // Logica specifica per la pagina partner
    if (document.location.pathname.match(/^\/partner\//)) {
      $item = $('.component-anchor-nav__items__item').first();
      if ($item.length > 0) {
        activateMenuItem($item);
      }
    // Tutti gli altri casi
    } else {
      navigateToAnchor(document.location.hash.toLowerCase(), null, true);
    }
  }
});
